import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Header from "components/Header";
import TabsNavigator from "components/TabsNavigator";
import CurrencyExchangeRate from "./currencyExchangeRate";
import SlipBotSettings from "./slipBotSettings";
import ParcelMonitorSettings from "./parcelMonitorSettings";
import CompanyInfoSettings from "./companyInfoSettings";


const Settings = () => {
  const { t } = useTranslation();

  const tabItems = [
    {
      text: "Currency Exchage Rate",
      component: <CurrencyExchangeRate/>,
      slug: "settings/exchange-rate",
    },
    {
      text: t("settings.slipBot.tab"),
      component: <SlipBotSettings/>,
      slug: "settings/slipbot",
    },
    {
      text: "Parcel Monitoring",
      component: <ParcelMonitorSettings/>,
      slug: "settings/parcel-monitoring",
    },
    {
      text: t("settings.companyInfo.tab"),
      component: <CompanyInfoSettings/>,
      slug: "settings/company-info",
    },
  ];

  return (
    <Box m="0 1rem">
      <Header title="Settings"/>
      <TabsNavigator tabItems={tabItems} pageSlug="settings" />
    </Box>
  );
};

export default Settings;
